import React from 'react';
import ProductList from '../../components/Products/ProductList';

const ProductsPage: React.FC = () => {
    return <ProductList />;
};

export default ProductsPage; 